import { Grid } from '@mui/material'
import { Actions } from '../interest-rates/actions'
import { InterestRatePeriodsTable } from '../interest-rates/interest-rate-periods-table'

export const InterestRatesView: React.FC = () => {
    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Actions />
                </Grid>
                <Grid item xs={12}>
                    <InterestRatePeriodsTable />
                </Grid>
            </Grid>
        </div>
    )
}
